// @flow
import client from '../../client'
import format from '../../utils/format'
import jwt from '../../utils/jwt'

// API Endpoints
export const USER_ENDPOINT = '/auth/users/{0}/'

/**
 * Changes the user's phone number.
 * @param  {Object} data Phone information object.
 * @param  {string} data.country_code_name The new phone country code.
 * @param  {string} data.phone_number_national The new phone number.
 * @return {Promise|Error} A resolved Promise with an user object whether the phone change
 *                         was successful or Rejected with an Error
 */
export const changePhone = (data: {
  country_code_name: string,
  phone_number: string,
}): Promise<any> => {
  const userId = jwt.getAuthorizedUserId()

  const options = {
    body: { ...data },
  }

  const endpoint = format(USER_ENDPOINT, userId)

  // API v2 returns the whole user data object for this service.
  return client.patch(endpoint, options)
}

export default changePhone
